module.exports = __webpack_public_path__ + "static/media/card_sort_smaller.55a72b82.gif";